<template>
<div class="question">
  <transition name="collapse">
    <div class="question-help-label" v-if="showIntro">{{labels['question-label']}}</div>
  </transition>
  <div class="question-label">{{labels[item.label]}}</div>
  <ul class="question-options">
    <li class="question-option" :key="option.label" v-for="option in item.options" @click="$emit('option-click', {question: item, option: option})">{{labels[option.label]}}</li>
  </ul>
  <div v-if="item.note && noteVisible" class="question-note" v-html="labels[item.note]" />
</div>
</template>

<script>
export default {
  name: 'Question',
  props: ['item', 'labels', 'showIntro', 'path'],
  computed: {
    noteVisible () {
      if (this.item.notecondition) {
        return this.path.indexOf(this.item.notecondition) > -1
      }
      return true
    }
  }
}
</script>

<style scoped lang="scss">
.question {
    padding-top: 10px;
    .question-help-label {
        overflow: hidden;
        flex: 1;

        max-height: 20px;

        font-size: 18px;
    }
    .question-label {
        flex: 1;

        margin-top: 10px;
        margin-bottom: 20px;

        font-size: 24px;
        font-weight: bold;
        line-height: 32px;
    }
    .question-note {
        margin-top: 30px;
    }
    .question-options {
        display: flex;
        flex-direction: column;

        margin-top: 30px;
        .question-option {
            min-width: 80px;
            margin-top: -1px;
            padding: 14px 14px 11px;

            cursor: pointer;
            cursor: pointer;
            transition: box-shadow 100ms, transform 100ms, background-color 100ms;
            text-align: center;

            color: #004f84;
            border: 1px solid #509dd1;
            background-color: rgba(206,224,239,.2);

            font-size: 16px;
            &::before {
                content: '';
            }
            &:first-child {
                border-top-left-radius: 3px;
                border-top-right-radius: 3px;
            }
            &:last-child {
                border-bottom: 1px solid #509dd1;
                border-bottom-right-radius: 3px;
                border-bottom-left-radius: 3px;
            }
            &:hover {
                z-index: 1;

                transform: scale(1.008, 1.008);

                background-color: #fff;
                box-shadow: 3px 3px 10px rgba(#5289C1, 0.3);
            }
        }
    }
    .collapse-enter-active,
    .collapse-leave-active {
        transition: opacity 100ms, max-height 300ms;
    }
    .collapse-enter,
    .collapse-leave-to {
        max-height: 0;

        opacity: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Question.vue